import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { container, sectionPad, label } from "@/lib/ui";
import { FAQS } from "@/data/content";

export function FaqSection({ limit = 6, showViewAll = true }) {
  const items = limit ? FAQS.slice(0, limit) : FAQS;
  return (
    <section className={`${sectionPad} bg-white`} data-testid="faq-section">
      <div className={`${container} grid lg:grid-cols-[0.9fr_1.1fr] gap-12`}>
        <div>
          <span className={label}>FAQ</span>
          <h2 className="mt-3 font-heading text-3xl lg:text-4xl font-bold tracking-tight text-navy">
            Questions? We've got answers
          </h2>
          <p className="mt-4 text-gray-600 leading-relaxed">
            Everything you need to know about our residential cleaning in Melbourne. Still unsure? Reach out
            any time — we're happy to help.
          </p>
          {showViewAll && (
            <Link
              to="/faq"
              className="mt-6 inline-flex items-center gap-1.5 font-semibold text-brandgreen-dark hover:text-brandgreen transition-colors"
              data-testid="faq-view-all"
            >
              View all FAQs <ArrowRight className="w-4 h-4" />
            </Link>
          )}
        </div>

        <Accordion type="single" collapsible className="w-full space-y-3" data-testid="faq-accordion">
          {items.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              className="rounded-2xl border border-gray-100 bg-neutralbg/60 px-5 data-[state=open]:bg-white data-[state=open]:shadow-sm"
            >
              <AccordionTrigger className="text-left font-heading font-semibold text-navy hover:no-underline py-5">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-sm text-gray-600 leading-relaxed pb-5">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
